<app-picture-expansion-panel></app-picture-expansion-panel>